<template>
    <RouterView />
</template>

<script lang="ts" setup>
import { onBeforeMount, onServerPrefetch, useSSRContext } from 'vue'
import { useRoute } from 'vue-router'

import { useAppStore } from '@/store/app-store'
import type { RenderCacheContext } from '@/types'

const appStore = useAppStore()
const route = useRoute()

onServerPrefetch(() => {
    const context = useSSRContext<RenderCacheContext>()
    if (!context) {
        return
    }

    appStore.initialize({
        host: context.host,
        initialQuery: route.query,
        platform: context.platform,
        isNativeIos: false,
        isNativeAndroid: false,
        appVersion: undefined,
        countryCode: undefined,
        clid: 'kids',
        experiments: {},
        rankingParams: {},
    })
})

// oxlint-disable-next-line playgama/no-on-before-mount
onBeforeMount(() => {
    appStore.setLoggingEnabled(false)
})
</script>
